import React, { Component } from 'react';
import ReactEcharts from "echarts-for-react";
import 'echarts/map/js/china';

class China extends Component {

    getOption = () => {

        return {

            tooltip: {
                backgroundColor: "#4169E1",//提示标签背景颜色
                formatter: function (params) {
                    console.log(params)
                    if (params.data) {
                        return `${params.name}<br/>
                        已报到:${params.data.arrived}<br/>未报到:${params.data.shouldArrive * 1 - params.data.arrived * 1}<br/>
                        报到率:${(params.value * 1 || 0).toFixed(2) + '%'}`;
                    } else {
                        return params.name
                    }
                }
            },
            visualMap: {
                show: false,
                inRange: {
                    color: ['#fff', '#70b4ff']
                },
                min: 0,
                max: 100
            },

            geo: {
                map: "china",
                roam: false,
                scaleLimit: {
                    min: 1.2,
                    max: 1.2
                },
                zoom: 1.5,
                top: 40,
                itemStyle: {
                    normal: {
                        borderColor: "#5bdbf3",
                        areaColor:'#fff'
                    },
                    emphasis: {
                        areaColor: "#4da1ff",
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        borderWidth: 0,
                        color: '#fff'
                    },
                    areaColor: "#2b7dd8"
                }
            },
            series: [{
                name: "",
                type: "map",
                geoIndex: 0,
                data: this.props.data || [],
            }]

        }
    }
    render() {
        return <ReactEcharts
            style={{
                width: '100%',
                height: "100%",
                padding: '0.50rem 0.10rem 0.10rem 0.10rem'
            }}
            option={this.getOption()}
            theme="clear"
        />
    }
}
export default China